module.exports = __webpack_public_path__ + "static/media/tiktok-icon.dcb4a026.svg";